import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import EditableRichText from "./UIParts/EditableRichText";
import { ContentItem } from "../interfaces/DTO/crm/contactComment";
import { convertHtmlToWhatsappText } from "../utils/whatsappUtils";
import { formatIsoDateWithTime } from "../utils/namesFormater";


interface Props {
  item: ContentItem;
  onDelete?: (itemId: number) => void;
  onEdit?: (itemId: number, newValue: string) => void;
}

export const RichTextDisplayListItem: React.FC<Props> = ({
  item,
  onDelete,
  onEdit,
}) => {
  const handleCopy = () => {
    const text = convertHtmlToWhatsappText(item.content || "");
    navigator.clipboard.writeText(text);
  };


  return (
    <Box sx={{ border: "1px solid #ddd", borderRadius: 1, p: 2 ,width: "100%"}}>
 
        {/* תאריכים */}
        <Box sx={{ whiteSpace: "nowrap", color: "gray", fontSize: "0.75rem", minWidth: "120px", textAlign: "right" }}>
          <div>{item.created_at && formatIsoDateWithTime(item.created_at)}</div>
          {item.updated_at && item.updated_at !== item.created_at && (
            <div>{formatIsoDateWithTime(item.updated_at)}</div>
          )}
        </Box>

        {/* טקסט ועורך */}
        <Box  sx={{ flex: 1, width: "100%" }}>
          <EditableRichText
            value={item.content || ""}
            onSave={(newValue) => onEdit?.(item.id, newValue)}
            onDelete={onDelete ? () => onDelete(item.id) : undefined}
            isLoading={false}
            enableEditing
            onCopy={handleCopy}
          />
        </Box>
   
    </Box>
  );
};
